/**
 * Created by Ewald Stamp (ewald.stamp@netmills.de) on 05.03.15.
 */

angular.module('farmnet.partner.fendt').service('fendtVarioDocAlerts', [
  '$rootScope',
  'fendtVarioDocLocale',
  function($rootScope, fendtVarioDocLocale) {
    'use strict';

    var alertController = $rootScope.alertController;

    var supportedHintAlert = null;
    var willSendDataAlert = null;

    this.showSupportedHint = function() {
      supportedHintAlert = alertController.addTemporaryAlert(
        fendtVarioDocLocale.alerts.supportedHint,
        'info'
      );
    };

    this.showWillSendData = function() {
      if (supportedHintAlert !== null) {
        alertController.closeAlert(supportedHintAlert);
        supportedHintAlert = null;
      }

      willSendDataAlert = alertController.addTemporaryAlert(
        fendtVarioDocLocale.alerts.willSendData,
        'info'
      );
    };

    this.showSendSuccess = function() {
      if (supportedHintAlert !== null) {
        alertController.closeAlert(supportedHintAlert);
        supportedHintAlert = null;
      }

      if (willSendDataAlert !== null) {
        alertController.closeAlert(willSendDataAlert);
        willSendDataAlert = null;
      }

      alertController.addTemporaryAlert(
        fendtVarioDocLocale.alerts.sendSuccess,
        'success'
      );
    };

    this.showSendFailure = function() {
      if (supportedHintAlert !== null) {
        alertController.closeAlert(supportedHintAlert);
        supportedHintAlert = null;
      }

      if (willSendDataAlert !== null) {
        alertController.closeAlert(willSendDataAlert);
        willSendDataAlert = null;
      }

      alertController.addPageAlert(
        fendtVarioDocLocale.alerts.sendFailure,
        'error'
      );
    };
  }
]);
